
/*
  This component will display steps in configurator
 */

import React, {useState} from 'react'
import Select from '../../common_elements/Select'
import Radio from '../../common_elements/Radio'
import { useDispatch, useSelector} from "react-redux";
import {patternSideSelectionChanged} from "../../../store/product/patternSelectionsSlice";
import ExceptionMessage from "../../common_elements/ExceptionMessage";


const PatternOption = (props) => {
    const dispatch = useDispatch();
    const disabledFields = useSelector(state => state.disabledFieldsReducer.sideDisabledFields);
    const [exceptionLeft, setExceptionLeft] = useState(0);
    const [message, setMessage] = useState([]);
    const [showException, setShowException] = useState(false);

    // this generates unique key, used for radiobutton group
    const generateKey = (option) => {
        return `configurator_pattern_option_${option.id}`;
    }

    const handleChange = (attribute, value) => {
        dispatch(patternSideSelectionChanged(attribute, value, props.patternSideKey ))
    }

    const displayOptions = () => {
        const options = props.options;
        const selections = props.selections;
        if(!options){
            return
        }
        const toDisplay = [];
        // go through each option and add it to the array to display
        options.forEach(function(option, index){
            // check store for a selection for this option, and pass it to children
            const currentSelection = selections.find((opt) => opt.id == option.id);
            const currentValue = currentSelection ? currentSelection.selection : null;
            toDisplay.push(radioOrSelect(option, currentValue));
        }, this)

        return ( toDisplay )
    }

    const shouldDisableSelect = (attribute, disabled) => {
        const selections = attribute.values.split(",");
        return selections.length == disabled.length;
    }

    const handleDisabledClick = (e, option) => {
        setShowException(true);
        const mouseX = e.pageX;
        const disabledSelections = getMatchingDisabledSelections(option);
        const message = disabledSelections.messages
        setExceptionLeft(mouseX);
        setMessage(message);
    }

    const hideExceptionMessage = () => {
        setMessage([]);
        setShowException(false);
    }

    const getMatchingDisabledSelections = (option) => {
        const disabledSide = disabledFields.find(side => Object.keys(side)[0] == props.patternSideKey)
        if(!disabledSide){
            return;
        }
        const disabledSideSelections = disabledSide[props.patternSideKey];
        const matchingField = disabledSideSelections.find(obj => obj.field == option.name);
        return matchingField;
    }

    const getDisabledSelections = (option) => {
        if(disabledFields == null ){
            return;
        }
        const matchingField = getMatchingDisabledSelections(option)
        return matchingField ? matchingField.disabledSelections : [];
    };

    // this piece of code determine wether we render a select box for attribute or a radio button
    const radioOrSelect = (option, selection) => {
        let values = option.values;
        const disabledSelections = getDisabledSelections(option)
        if (values.length > 1) {
            const shouldDisable = shouldDisableSelect(option, disabledSelections);
            return (
                <li  key={generateKey(option)}>
                    <label className={"label_select " + (shouldDisable ? 'disabled':'enabled')}>
                        { option.name }
                        {/*<Select attributes={option} product={props.product} exceptions={getMatchingExceptions(option)} patternSideKey={props.patternSideKey} propType={'PATTERN-OPTION'} currentValue={selection} fieldId={props.index} hasEmptyField={true} handleChange={(option) => updateLinkableOptions(option)} onClick={(e) => handleDisabledClick(e, option)} onChange={() => hideExceptionMessage()}/>*/}
                        <Select attributes={option} product={props.product} patternSideKey={props.patternSideKey} propType={'PATTERN-OPTION'} currentValue={selection} fieldId={props.index} hasEmptyField={true} handleAttribute={(value) => handleChange(option, value)} onChange={() => hideExceptionMessage()} disabledSelections={disabledSelections} onClick={(e) => handleDisabledClick(e, option)}/>
                    </label>
                </li>
            )
        } else {
            // return  <li  key={generateKey(option)} onClick={(e) => handleDisabledClick(e, option)}><Radio patternSideKey={props.patternSideKey} attributes={option} exceptions={getMatchingExceptions(option)} product={props.product} propType={'PATTERN-OPTION'} currentValue={selection} group={generateKey(option)} checkType={'checkbox'} fieldId={props.index} onChange={() => hideExceptionMessage()}/></li>
            return  <li  key={generateKey(option)}><Radio patternSideKey={props.patternSideKey} attributes={option} product={props.product} propType={'PATTERN-OPTION'} currentValue={selection} group={generateKey(option)} checkType={'checkbox'} handleAttribute={(value) => handleChange(option, value)} fieldId={props.index} disabledSelections={disabledSelections} onClick={(e) => handleDisabledClick(e, option)}/></li>
        }
    }

    const exceptionMessage = () => {
        if(!showException || message.length == 0){
            return;
        }

        return <ExceptionMessage  message={message} posLeft={exceptionLeft}/>
    }
    return (
        <div className="side-step" style={{position: 'relative'}} onMouseLeave={() => hideExceptionMessage()} >
            <div className="row flex-row">
                <div className="title small-12 medium-2 columns">
                    <h3>Options</h3>
                </div>
                <div className="selection small-12 medium-10 columns">
                    <fieldset style={{width: '100%'}}>
                        <ul className="small-block-grid-1 medium-block-grid-2 optional-attribute-list">
                            {displayOptions() }
                        </ul>
                    </fieldset>
                </div>
            </div>
            { exceptionMessage() }
        </div>
    )
}

export default PatternOption;
